import React, { useEffect, useState } from 'react';
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import './App.css';

function App() {
  // Read query parameters
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token"); // "token" is the query parameter name
  const initialDarkMode = urlParams.get("darkMode") === 'true'; // "darkMode" query parameter
  const currentPageUrl = new URL(window.location.href);
  const normalizedSwaggerPath = currentPageUrl.pathname.endsWith('/index.html')
    ? currentPageUrl.pathname.slice(0, -'index.html'.length)
    : currentPageUrl.pathname.endsWith('/')
      ? currentPageUrl.pathname
      : `${currentPageUrl.pathname}/`;
  const swaggerDocumentUrl = `${currentPageUrl.origin}${normalizedSwaggerPath}doc.json`;

  const [isDarkTheme, setIsDarkTheme] = useState(initialDarkMode);

  // Function to apply the dark theme
  const applyDarkTheme = () => {
    const swaggerContainer = document.querySelector('.swagger-ui');
    if (swaggerContainer) {
      if (isDarkTheme) {
        document.body.classList.add('dark-theme');
        swaggerContainer.classList.add('dark-theme');
      } else {
        document.body.classList.remove('dark-theme');
        swaggerContainer.classList.remove('dark-theme');
      }
    } else {
      console.log('Swagger container not found');
    }
  };

  useEffect(() => {
    // Apply the theme whenever isDarkTheme changes
    applyDarkTheme();
  }, [isDarkTheme]);

  // Function to authorize after Swagger UI is loaded
  const onSwaggerComplete = (swaggerUI) => {
    if (token) {
      swaggerUI.authActions.authorize({
        BearerAuth: {
          name: "BearerAuth",
          schema: {
            type: "http",
            scheme: "bearer",
            bearerFormat: "JWT",
          },
          value: `${token}`,
        },
      });
    } else {
      console.log('No token provided');
    }

    // Apply dark theme if necessary
    applyDarkTheme();
  };

  // Listen for messages from the parent window to update dark mode
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.darkTheme !== undefined) {

        setIsDarkTheme(event.data.darkTheme);
      }
    };

    window.addEventListener('message', handleMessage);

    // Cleanup on component unmount
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <div className="App">
      <SwaggerUI
        url={swaggerDocumentUrl}
        tryItOutEnabled={false}
        persistAuthorization={true}
        onComplete={onSwaggerComplete}
        requestInterceptor={(req) => {
          if (token) {
            req.headers['Authorization'] = `Bearer ${token}`;
          }
          return req;
        }}
      />
    </div>
  );
}

export default App;
